/**
 * Card Image Helper
 * 
 * Maps card IDs to actual images or generates placeholder SVGs.
 * Used when cards are stored without base64 image data.
 */

// ============================================================
// RELIABLE CARD IMAGE ASSETS - No broken images!
// ============================================================
const CARD_ASSETS = {
  // Tech Moguls - Using reliable Wikimedia/External URLs
  'bill gates': 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a8/Bill_Gates_2017_%28cropped%29.jpg/440px-Bill_Gates_2017_%28cropped%29.jpg',
  'bill': 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a8/Bill_Gates_2017_%28cropped%29.jpg/440px-Bill_Gates_2017_%28cropped%29.jpg',
  'gates': 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a8/Bill_Gates_2017_%28cropped%29.jpg/440px-Bill_Gates_2017_%28cropped%29.jpg',
  
  'elon musk': 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/34/Elon_Musk_Royal_Society_%28crop2%29.jpg/440px-Elon_Musk_Royal_Society_%28crop2%29.jpg',
  'elon': 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/34/Elon_Musk_Royal_Society_%28crop2%29.jpg/440px-Elon_Musk_Royal_Society_%28crop2%29.jpg',
  'musk': 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/34/Elon_Musk_Royal_Society_%28crop2%29.jpg/440px-Elon_Musk_Royal_Society_%28crop2%29.jpg',
  'dogefather': 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/34/Elon_Musk_Royal_Society_%28crop2%29.jpg/440px-Elon_Musk_Royal_Society_%28crop2%29.jpg',
  
  'jeff bezos': 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6d/Jeff_Bezos_at_Amazon_Spheres_Grand_Opening_in_Seattle_-_2018_%2839074799225%29_%28cropped%29.jpg/440px-Jeff_Bezos_at_Amazon_Spheres_Grand_Opening_in_Seattle_-_2018_%2839074799225%29_%28cropped%29.jpg',
  'jeff': 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6d/Jeff_Bezos_at_Amazon_Spheres_Grand_Opening_in_Seattle_-_2018_%2839074799225%29_%28cropped%29.jpg/440px-Jeff_Bezos_at_Amazon_Spheres_Grand_Opening_in_Seattle_-_2018_%2839074799225%29_%28cropped%29.jpg',
  'bezos': 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6d/Jeff_Bezos_at_Amazon_Spheres_Grand_Opening_in_Seattle_-_2018_%2839074799225%29_%28cropped%29.jpg/440px-Jeff_Bezos_at_Amazon_Spheres_Grand_Opening_in_Seattle_-_2018_%2839074799225%29_%28cropped%29.jpg',
  
  'mark zuckerberg': 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/Mark_Zuckerberg_F8_2019_Keynote_%2832830578717%29_%28cropped%29.jpg/440px-Mark_Zuckerberg_F8_2019_Keynote_%2832830578717%29_%28cropped%29.jpg',
  'zuckerberg': 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/Mark_Zuckerberg_F8_2019_Keynote_%2832830578717%29_%28cropped%29.jpg/440px-Mark_Zuckerberg_F8_2019_Keynote_%2832830578717%29_%28cropped%29.jpg',
  'zuck': 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/Mark_Zuckerberg_F8_2019_Keynote_%2832830578717%29_%28cropped%29.jpg/440px-Mark_Zuckerberg_F8_2019_Keynote_%2832830578717%29_%28cropped%29.jpg',
  
  // Crypto Icons
  'vitalik': 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/1c/Vitalik_Buterin_TechCrunch_London_2015_%28cropped%29.jpg/440px-Vitalik_Buterin_TechCrunch_London_2015_%28cropped%29.jpg',
  'vitalik buterin': 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/1c/Vitalik_Buterin_TechCrunch_London_2015_%28cropped%29.jpg/440px-Vitalik_Buterin_TechCrunch_London_2015_%28cropped%29.jpg',
  'buterin': 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/1c/Vitalik_Buterin_TechCrunch_London_2015_%28cropped%29.jpg/440px-Vitalik_Buterin_TechCrunch_London_2015_%28cropped%29.jpg',
  
  'cz': 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/Changpeng_Zhao_%28cropped%29.jpg/440px-Changpeng_Zhao_%28cropped%29.jpg',
  'changpeng zhao': 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/Changpeng_Zhao_%28cropped%29.jpg/440px-Changpeng_Zhao_%28cropped%29.jpg',
  
  // Investors
  'warren buffett': 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Warren_Buffett_KU_Visit.jpg/440px-Warren_Buffett_KU_Visit.jpg',
  'warren': 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Warren_Buffett_KU_Visit.jpg/440px-Warren_Buffett_KU_Visit.jpg',
  'buffett': 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Warren_Buffett_KU_Visit.jpg/440px-Warren_Buffett_KU_Visit.jpg',
  
  // Political Figures
  'donald trump': 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/56/Donald_Trump_official_portrait.jpg/440px-Donald_Trump_official_portrait.jpg',
  'trump': 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/56/Donald_Trump_official_portrait.jpg/440px-Donald_Trump_official_portrait.jpg',
  
  'vladimir putin': 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Vladimir_Putin_%282020-02-20%29.jpg/440px-Vladimir_Putin_%282020-02-20%29.jpg',
  'putin': 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Vladimir_Putin_%282020-02-20%29.jpg/440px-Vladimir_Putin_%282020-02-20%29.jpg',
  
  // Crypto Villains
  'sbf': 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/50/Sam_Bankman-Fried_%28cropped%29.jpg/440px-Sam_Bankman-Fried_%28cropped%29.jpg',
  'sam bankman-fried': 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/50/Sam_Bankman-Fried_%28cropped%29.jpg/440px-Sam_Bankman-Fried_%28cropped%29.jpg',
  'sam bankman fried': 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/50/Sam_Bankman-Fried_%28cropped%29.jpg/440px-Sam_Bankman-Fried_%28cropped%29.jpg',
};

// Rarity colors for generated cards
const RARITY_COLORS = {
  common: { bg: '#4A5568', accent: '#718096', text: '#E2E8F0', glow: '#4A556840' },
  rare: { bg: '#2B6CB0', accent: '#3182CE', text: '#BEE3F8', glow: '#2B6CB040' },
  epic: { bg: '#6B46C1', accent: '#9F7AEA', text: '#E9D8FD', glow: '#6B46C140' },
  legendary: { bg: '#C05621', accent: '#DD6B20', text: '#FEEBC8', glow: '#C0562140' },
};

// Class icons
const CLASS_ICONS = {
  warrior: '⚔️',
  mage: '🔮',
  rogue: '🗡️',
  tank: '🛡️',
  healer: '💚',
  support: '✨',
  default: '🃏',
};

/**
 * Get asset path by card ID or name
 */
export const getAssetById = (idOrName) => {
  if (!idOrName) return null;
  
  // Try numeric ID first
  if (typeof idOrName === 'number' || !isNaN(parseInt(idOrName))) {
    const numId = parseInt(idOrName);
    if (CARD_ASSETS[numId]) {
      return CARD_ASSETS[numId];
    }
  }
  
  // Try by name (normalized)
  const normalized = String(idOrName).toLowerCase().trim();
  if (CARD_ASSETS[normalized]) {
    return CARD_ASSETS[normalized];
  }
  
  return null;
};

/**
 * Generate a placeholder SVG for a card
 * Used when no image is available
 */
const generatePlaceholderSVG = (card) => {
  const rarity = card.rarity || 'common';
  const name = card.character_name || card.name || 'Unknown';
  const cardClass = card.card_class || 'default';
  const power = card.power_rating || card.power || 1;
  
  const color = RARITY_COLORS[rarity] || RARITY_COLORS.common;
  const icon = CLASS_ICONS[cardClass] || CLASS_ICONS.default;
  
  // Create SVG
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="200" height="280" viewBox="0 0 200 280">
      <defs>
        <linearGradient id="bg-${rarity}" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color:${color.bg}"/>
          <stop offset="100%" style="stop-color:${color.accent}"/>
        </linearGradient>
        <filter id="glow-${rarity}">
          <feGaussianBlur stdDeviation="3" result="blur"/>
          <feFlood flood-color="${color.accent}" flood-opacity="0.5"/>
          <feComposite in2="blur" operator="in"/>
          <feMerge>
            <feMergeNode/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      <!-- Background -->
      <rect width="200" height="280" rx="16" fill="url(#bg-${rarity})"/>
      
      <!-- Inner Border -->
      <rect x="6" y="6" width="188" height="268" rx="12" fill="none" stroke="${color.text}" stroke-opacity="0.3" stroke-width="2"/>
      
      <!-- Rarity Glow Effect -->
      <circle cx="100" cy="100" r="55" fill="none" stroke="${color.accent}" stroke-width="3" stroke-opacity="0.3" filter="url(#glow-${rarity})"/>
      
      <!-- Icon Circle -->
      <circle cx="100" cy="100" r="50" fill="${color.bg}" opacity="0.8"/>
      <circle cx="100" cy="100" r="45" fill="none" stroke="${color.text}" stroke-opacity="0.5" stroke-width="2"/>
      
      <!-- Class Icon -->
      <text x="100" y="115" text-anchor="middle" font-size="50">${icon}</text>
      
      <!-- Power Stars -->
      <text x="100" y="180" text-anchor="middle" font-size="18" fill="${color.text}">
        ${'★'.repeat(Math.min(power, 5))}${'☆'.repeat(Math.max(0, 5 - power))}
      </text>
      
      <!-- Name -->
      <text x="100" y="220" text-anchor="middle" font-family="Arial Black, sans-serif" font-size="14" font-weight="bold" fill="${color.text}">
        ${name.substring(0, 12).toUpperCase()}
      </text>
      
      <!-- Rarity Badge -->
      <rect x="50" y="240" width="100" height="28" rx="14" fill="${color.text}" fill-opacity="0.15"/>
      <text x="100" y="259" text-anchor="middle" font-family="Arial, sans-serif" font-size="11" font-weight="bold" fill="${color.text}">
        ${rarity.toUpperCase()}
      </text>
    </svg>
  `;
  
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

/**
 * Get card image - the main function to use
 * Checks for: existing image → asset by ID/name → generated placeholder
 * 
 * @param {Object} card - Card object with id, character_name, image_base64, etc.
 * @returns {string} Image URL (data URL, asset path, or generated SVG)
 */
export const getCardImageById = (card) => {
  if (!card) return generatePlaceholderSVG({ rarity: 'common', character_name: 'Unknown' });
  
  // 1. Check if card already has a valid image
  if (card.image_base64 && card.image_base64.length > 100) {
    // Ensure it has the data URL prefix
    if (card.image_base64.startsWith('data:')) {
      return card.image_base64;
    }
    return `data:image/png;base64,${card.image_base64}`;
  }
  
  // Also check 'image' field
  if (card.image && card.image.length > 100) {
    if (card.image.startsWith('data:') || card.image.startsWith('http')) {
      return card.image;
    }
    return `data:image/png;base64,${card.image}`;
  }
  
  // 2. Try to get from assets by ID
  if (card.id) {
    const assetPath = getAssetById(card.id);
    if (assetPath) return assetPath;
  }
  
  // 3. Try to get from assets by name
  if (card.character_name) {
    const assetPath = getAssetById(card.character_name);
    if (assetPath) return assetPath;
  }
  
  if (card.name) {
    const assetPath = getAssetById(card.name);
    if (assetPath) return assetPath;
  }
  
  // 4. Generate placeholder SVG
  return generatePlaceholderSVG(card);
};

/**
 * Get card rarity color
 */
export const getCardRarityColor = (rarity) => {
  const colors = {
    common: '#A0A0A0',
    rare: '#00CCFF',
    epic: '#FF00FF',
    legendary: '#FFD700',
  };
  return colors[rarity] || colors.common;
};

/**
 * Get card border style based on rarity
 */
export const getCardBorderStyle = (rarity) => {
  const color = getCardRarityColor(rarity);
  return {
    borderColor: color,
    boxShadow: `0 0 15px ${color}40, inset 0 0 10px ${color}20`,
  };
};

/**
 * Card Image Component
 * Use this component to render card images with proper fallbacks
 */
export const CardImageComponent = ({ card, className = '', style = {} }) => {
  const imageSrc = getCardImageById(card);
  const rarityColor = getCardRarityColor(card?.rarity);
  
  return (
    <div 
      className={`overflow-hidden ${className}`}
      style={{ 
        borderColor: rarityColor,
        ...style 
      }}
    >
      <img
        src={imageSrc}
        alt={card?.character_name || card?.name || 'Card'}
        className="w-full h-full object-cover"
        onError={(e) => {
          // Fallback to generated placeholder if image fails to load
          e.target.src = generatePlaceholderSVG(card || {});
        }}
      />
    </div>
  );
};

export default {
  getCardImageById,
  getAssetById,
  getCardRarityColor,
  getCardBorderStyle,
  CardImageComponent,
};
